// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdSurveyQuestionResponsesResult = objectOf({
  question_id: string,
  question_type: string,
  total_responses: number,
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      user_id: string,
      response: string,
      timestamp: number,
    })
  ),
});
